import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {


  set(key: string, value: any): void {
    const encryptvalue = CryptoJS.AES.encrypt(JSON.stringify(value), environment.cryptKey).toString();
    sessionStorage.setItem(key, encryptvalue);
  }

  get(key: string): any {
    const localStorageItem = sessionStorage.getItem(key) ?? '';

    if (localStorageItem) {
      return JSON.parse(CryptoJS.AES.decrypt(sessionStorage.getItem(key) ?? '', environment.cryptKey).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  clear(): void {
    sessionStorage.clear();
  }
}
